import { MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { useAuthStore } from "@store/auth.store";
import { Container, FormItem } from "./styles";

type Props = {
  size?: "small" | "large";
};

export function Settings(props: Props) {
  const { size = "large" } = props || {};
  const updatePreferences = useAuthStore((state) => state.updatePreferences);
  const preferences = useAuthStore((state) => state.preferences);

  const handleChangeTheme = (e: SelectChangeEvent) => {
    const theme = e.target.value as "light" | "dark" | "system";
    updatePreferences({ theme });
  };

  return (
    <Container size={size}>
      <FormItem size={size}>
        <Typography>Theme</Typography>
        <Select
          label="Theme"
          onChange={handleChangeTheme}
          value={preferences.theme}
          id="theme"
          sx={{ minWidth: 130 }}
        >
          <MenuItem value={"system"}>Automatic</MenuItem>
          <MenuItem value={"dark"}>Dark</MenuItem>
          <MenuItem value={"light"}>Light</MenuItem>
        </Select>
      </FormItem>
    </Container>
  );
}
